import lang from "@/views/modules/TicketSystems/language/en";
import alert from "@/views/shared/notify/Alert.vue";
//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-ticket",

    components: {
        //   'editor': Editor,
        alert
    },
    data() {
        return {
            loading: true,
            ticket: {
                documents: [],
                ed_support: false
            },
            lang: [],
            error_message: {
                request_to: '',
                desc: '',
            },
            showDropdown: null,
            dom_array: [],
            process: false,
            inputFile: false,
            allFiles: [],
            fileName: [],
            fileUpload: false,
            file_error:'',
        }
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
        this.ticket.status = this.dom_array.ticket_status.Open;
    },
    methods: {
        saveTicket() {
            const self = this;
            
            if(self.file_error == '')
            {
                self.process = true;
                axios.post('api/modules/ticketsystems', self.ticket).then(function (response) {
                    self.process = false;
                    self.$refs.notifyMsg.showAlert("Success", "Support request created");
                    setTimeout(() => {
                        self.$router.push('/modules/ticketsystems');
                    }, "2000");
                    
                }).catch(function () {
                    self.process = false;
                    let allerror = document.getElementsByClassName('error');
                    for (let i = 0; i < allerror.length; i++) {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];

                        let error_el = document.getElementById(key + "_error");
                        error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                });
            }else{
                self.$refs.notifyMsg.showAlert("Error", "Please check your request");
            }
        },
        changeFile(e, fieldName) {
            const self = this;
            const fileInput = e.target;
            this.file_error = '';
        
            const files = Array.from(fileInput.files);
            if (!files.length) return;
        
            // ----------------------------
            // 1. FILE COUNT VALIDATION
            // ----------------------------
            const MAX_FILES = 5;
            if (files.length > MAX_FILES) {
                this.file_error = "You can upload a maximum of 5 files only.";
                fileInput.value = '';
                return;
            }
            // ----------------------------
            // 2. FILE NAME VALIDATION
            // ----------------------------
            const MAX_FILE_NAME_LENGTH = 40;

            for (const file of files) {
                if (file.name.length > MAX_FILE_NAME_LENGTH) {
                    this.file_error =
                        `File name "${file.name}" cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;

                    fileInput.value = '';
                    return;
                }
            }        
            // ----------------------------
            // 3. TOTAL SIZE VALIDATION (8 MB)
            // ----------------------------
            let setSize = window.app.max_file_size;
            const MAX_TOTAL_SIZE = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024);
            const totalSize = files.reduce((sum, file) => sum + file.size, 0);
        
            if (totalSize > MAX_TOTAL_SIZE) {
                this.file_error = "Total file size should not exceed 8 MB.";
                fileInput.value = '';
                return;
            }
        
            // Reset array (important for re-upload)
            this.ticket.documents = [];
        
            // ----------------------------
            // 4. PROCESS EACH FILE
            // ----------------------------
            files.forEach(file => {
        
                // ---- Extension + MIME ----
                const ext = file.name.split('.').pop().toLowerCase();
                const mime = file.type || this.getMimeByExt(ext);
        
                // ---- Read Base64 ----
                const reader = new FileReader();
                reader.onload = function (ev) {
                    self.ticket.documents.push({
                        base64: ev.target.result,   // full data URI
                        ext: ext,
                        mime: mime,
                        original_name: file.name
                    });
        
                   // self.ticket.ed_support = true;
                    self.$forceUpdate();
                };
                reader.readAsDataURL(file);
            });
        },       
        getMimeByExt(ext) {
            const map = {
                'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'xls':  'application/vnd.ms-excel',
                'csv':  'text/csv'
            };
            return map[ext] || 'application/octet-stream';
        },        
        openComponent(routeName, moduleName, field_id, queryData = null) {
            this.field_id = field_id;
            this.windowRef = window.open(`/popup?module=${routeName}&body=modal&callback=parentMethod&use_type=RM&moduleName=${moduleName}`, "", "width=900,height=400,left=200,top=200");
            this.parentCompnent = routeName;
            this.windowRef.addEventListener('beforeunload', this.parentMethod);

        },
        parentMethod() {
            const module_name = this.parentCompnent.slice(0, -1);
            const parent_id = localStorage.getItem('parentid');
            const parent_name = localStorage.getItem('parentname');
            const parent_type = localStorage.getItem('parenttype');
            this.selectElement(module_name, parent_name, parent_id, parent_type);

            if (this.windowRef) {
                this.windowRef.close();
                this.windowRef = null;
                this.$emit('close');
            }
            localStorage.removeItem('parentid');
            localStorage.removeItem('parentname');
            localStorage.removeItem('parenttype');

        },
        updateItem(id, name, type) {
            this.showDropdown = false;
            const module_name = type;
            this.selectElement(module_name, name, id, type);
        },
        selectElement(moduleName, name = null, id = null, module = null) {

            const module_name = moduleName.replace("-", "_");
            const p_name = module_name + '_name';
            const p_name_el = document.getElementById(p_name);

            p_name_el.value = name;
            p_name_el.dispatchEvent(new Event('input'));
            const p_id = this.field_id;
            const p_id_el = document.getElementById(p_id);
            p_id_el.value = id;
            p_id_el.dispatchEvent(new Event('input'));
            //this.field_id = null;

        },
        clearComponent(modulesLink) {
            const self = this;
            self.dropdownList = [];
            if (self.dropdownList.length == 0) {
                self.selectElement(modulesLink, '', '', '');
            }
        },
        queryForKeywords(e, modulesLink, field_id) {
            const self = this;
            self.field_id = field_id;
            let searchData = e.target.value;
            let relatedModule = modulesLink + 's';
            self.showDropdown = null;

            if (searchData.length > 0) {
                axios.post(`api/modules/searchItem`, { 'name': searchData, 'relatedModule': relatedModule, 'fromModule': 'TicketSystems' }).then(function (response) {
                    self.dropdownList = response.data;
                    self.showDropdown = field_id;
                });
            } else {
                self.showDropdown = false;
                self.dropdownList = [];

                if (searchData.length == 0) {
                    self.selectElement(modulesLink, '', '', '');
                }

            }
        },

    }
}